module.exports = __webpack_public_path__ + "static/img/85-3.0abdac4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/85-3.jpg
// module id = uzX0
// module chunks = 0